// Module
var code = `<section class="deeplink-desktop">

    <div class="deeplink-desktop__shell">

        <div class="deeplink-desktop__banner">

            <img
                class="deeplink-desktop__banner-background"
                ng-src="{{ \$ctrl.data.desktop.bannerBackground }}"
                alt=""
                aria-hidden="true">

            <img
                class="deeplink-desktop__banner-logo"
                ng-src="{{ \$ctrl.data.desktop.bannerLogo }}"
                alt="Toke">

            <div class="deeplink-desktop__banner-art">

                <div class="deeplink-desktop__banner-glow"></div>

                <div class="deeplink-desktop__banner-line deeplink-desktop__banner-line--top"></div>

                <div class="deeplink-desktop__banner-line deeplink-desktop__banner-line--middle"></div>

            </div>

        </div>

        <img
            class="deeplink-desktop__banner-decal deeplink-desktop__banner-decal--bottom"
            ng-src="{{ \$ctrl.data.desktop.bottomDecal }}"
            alt=""
            aria-hidden="true">

        <img
            class="deeplink-desktop__floating-decal"
            ng-src="{{ \$ctrl.data.desktop.topDecal }}"
            alt=""
            aria-hidden="true">

        <div class="deeplink-desktop__content">

            <h1 class="deeplink-desktop__title">
                {{ \$ctrl.data.desktop.title }}
            </h1>

            <p class="deeplink-desktop__subtitle">
                {{ \$ctrl.data.desktop.subtitle }}
            </p>

            <p class="deeplink-desktop__helper-text">
                {{ \$ctrl.data.desktop.helperText }}
            </p>

            <div class="deeplink-desktop__qr"></div>

            <button
                type="button"
                class="deeplink-desktop__copy"
                ng-class="{
                    'deeplink-desktop__copy--success':
                        \$ctrl.copyStatus === 'success'
                }"
                ng-click="\$ctrl.copyLink()">

                <img
                    class="deeplink-desktop__copy-icon"
                    ng-src="{{
                        \$ctrl.copyStatus === 'success'
                            ? \$ctrl.data.desktop.checkIcon
                            : \$ctrl.data.desktop.copyIcon
                    }}"
                    alt=""
                    aria-hidden="true">

                <span class="deeplink-desktop__copy-label">

                    {{
                        \$ctrl.copyStatus === 'success'
                            ? 'Enlace copiado'
                            : \$ctrl.data.desktop.copyLabel
                    }}

                </span>

            </button>

        </div>

    </div>

</section>`;
// Exports
export default code;